<template>
  <div>
    <div class="ps-px-4 ps-py-4">
      <base-label>Description</base-label>
      <div
        class="ps-mt-1 ps-bg-white ps-pl-3 ps-py-2  ps-rounded ps-border ps-border-solid ps-border-gray-300"
      >
        <markdown-editor
          class="ps-text-sm ps-text-gray-900 ps-leading-normal"
          v-model="$v.card.desc.$model"
          :create-mode="isCreateMode"
        />
      </div>

      <div class="ps-w-full ps-mt-6">
        <base-form-field
          label="List"
          input-name="TailwindSelect"
          :vuelidate="$v.card.list_id"
          :options="lists"
          placeholder="Choose a List:"
        />
      </div>

      <div class="ps-w-full ps-mt-6">
        <base-form-field
          v-if="users.length"
          label="Assign To"
          input-name="TailwindSelect"
          :vuelidate="$v.card.assigned_to_user_id"
          :options="users"
          :user-avatar="true"
          placeholder="Choose a User:"
        />
      </div>

      <div class="ps-flex ps-mt-6">
        <div v-for="f in fields" :class="[f.wrapper_class]">
          <base-form-field
            :label="f.label"
            :input-name="f.input_type"
            :vuelidate="$v.card[f.name]"
            :options="find(f.service)"
            :placeholder="f.placeholder"
          />
        </div>
      </div>

      <div v-if="!isCreateMode" class="ps-mt-6">
        <div class="ps-flex">
          <div class="ps-w-full">
            <meta-display
              label="Created By"
              :timestamp="$v.card.created_at.$model.distance_to_now"
              source="Picnic"
              :user="$v.card.created_by_user.$model"
            >
            </meta-display>
          </div>
          <!-- <div class="ps-w-1/2 ps-ml-2">
            <meta-display
              v-if="$v.updated_at.$model"
              label="Modified At"
              :timestamp="$v.updated_at.$model.distance_to_now"
              source="Picnic"
            >
              <div class="ps-flex ps-items-center ">
                <img
                  class="ps-w-6 ps-h-6 ps-rounded-sm ps-overflow-hidden ps-block"
                  src="https://avatar-cdn.atlassian.com/f43be2f3624611b9d067975181f07861?s=48&amp;d=https%3A%2F%2Fsecure.gravatar.com%2Favatar%2Ff43be2f3624611b9d067975181f07861%3Fd%3Dmm%26s%3D48%26noRedirect%3Dtrue"
                />
                <p class="ps-flex-auto ps-pl-2 ps-text-sm">User</p>
              </div>
            </meta-display>
          </div> -->
        </div>
      </div>

      <!-- <div v-if="!isCreateMode" class="ps-mt-3 ps-flex">
        <div class="ps-w-1/2 ps-pr-2">
          <base-label>Provider</base-label>
          <div class="ps-bg-brand-brown-100 ps-p-3 ps-rounded">
            <p class="ps-text-sm">Picnic</p>
          </div>
        </div>

        <div class="ps-w-1/2 ps-pl-2">
          <base-label>ID</base-label>
          <div class="ps-bg-brand-brown-100 ps-p-3 ps-rounded">
            <p class="ps-text-sm">{{ $v.id.$model }}</p>
          </div>
        </div>
      </div> -->

      <div v-if="!isCreateMode" class="ps-mt-6">
        <copy-link
          class="ps-text-sm ps-rounded ps-overflow-hidden"
          label="Picnic Link"
          :value="picnicUrl"
          :vuelidate="{}"
        ></copy-link>
      </div>

      <!-- <base-form-field
        label="Assigned To"
        input-name="BaseSelect"
        :vuelidate="$v.assigned_to"
        :options="users"
      >
        <span class="" v-if="showAssignToOwner">
          <a href="#" @click.prevent.stop="assignToOwner"
            >Assign to <br />creator
          </a>
        </span>
      </base-form-field>

      <div class="ps-my-3">
        <base-form-field
          label="Status"
          input-name="BaseSelect"
          :vuelidate="$v._status"
          :options="statuses"
          placeholder="-- Choose a Status:"
        />
      </div>

      <div class="ps-flex ps-mb-3">
        <div class="ps-w-1/2 ps-pr-2">
          <base-form-field
            label="Type"
            input-name="BaseSelect"
            :vuelidate="$v._type"
            :options="types"
            placeholder="-- Choose Type:"
          />
        </div>

        <div class="ps-w-1/2 ps-pl-2">
          <base-form-field
            label="Priority"
            input-name="BaseSelect"
            :vuelidate="$v._priority"
            :options="priorities"
            placeholder="-- Choose a Priority:"
          />
        </div>
      </div>

      <div v-if="typeIsSubTask" class="ps-mb-3">
        <base-form-field
          label="Parent Issue"
          input-name="BaseSelect"
          :vuelidate="$v._parent"
          :options="parentTickets"
          placeholder="-- Choose a Parent Issue:"
        >
          <p v-if="loadingIntTickets">...Finding Parent Issues...</p>
        </base-form-field>
      </div>

      <div v-if="!typeIsSubTask" class="ps-mb-3">
        <base-form-field
          label="JIRA Epics"
          input-name="BaseSelect"
          :vuelidate="$v._epic"
          :options="epics"
          placeholder="-- Choose an Epic:"
        />
      </div>

      <div v-if="!typeIsSubTask" class="ps-mb-3">
        <base-form-field
          label="JIRA Sprints"
          input-name="BaseSelect"
          :vuelidate="$v._sprint"
          :options="sprints"
          placeholder="-- Choose a Sprint:"
        />
      </div> -->

      <!-- <div v-if="$v.snapshot" class="ps-bg-indigo ps-p-4">
        <a
          href="https://rei.com"
          target="_blank"
          class="ps-flex ps-items-center"
        >
          <span class="ps-w-6 ps-h-6 ps-flex ps-items-center ps-justify-center">
            <svg-icon name="snapshot" width="98%" height="auto" />
          </span>
          <span class="ps-flex-auto ps-pl-3">
            <svg-icon name="snapshot-title" width="100" height="auto" />
          </span>
          <span
            class="ps-w-12 ps-h-12 ps-flex ps-items-center ps-justify-center ps-svg-down"
          >
            <svg-icon name="go" width="16" height="auto" />
          </span>
        </a>
      </div>

      

     

       -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from '@picnic-software/vuex'
import BaseFormData from '@/components/forms/BaseFormData'
import BaseFormField from '@/components/forms/BaseFormField'
import BaseLabel from '@/components/forms/BaseLabel'
import BaseSelect from '@/components/inputs/BaseSelect'
import ButtonIcon from '@/components/buttons/ButtonIcon'
import BaseUser from '@/components/BaseUser'
import MarkdownEditor from '@/components/MarkdownEditor'
import CopyLink from '@/components/CopyLink'
import MetaDisplay from '@/components/MetaDisplay'
import UserAvatar from '@/components/UserAvatar'
import '@/icons/go'
import '@/icons/snapshot'
import '@/icons/snapshot-title'

export default {
  name: 'CardSectionDetails',
  extends: BaseFormData,
  props: {
    typeIsSubTask: Boolean,
    isCreateMode: Boolean,
    pages: {
      type: Array,
      default: () => []
    },
    dotId: [Number, String],
    picnicUrl: String
  },
  components: {
    BaseFormField,
    BaseSelect,
    MarkdownEditor,
    CopyLink,
    MetaDisplay,
    ButtonIcon,
    BaseUser,
    BaseLabel,
    UserAvatar
  },
  data() {
    return {
      loadingIntTickets: false
    }
  },
  computed: {
    ...mapState({
      fields: state => state.provider.fields.all,
      lists: state => state.provider.lists.all
    }),
    ...mapGetters({
      users: 'provider/users/asOptions'
    }),
    showAssignToOwner() {
      if (this.isCreateMode) return
      if (!this.$v._user_strategy_id.$model) return
      const ticketOwner = this.$store.getters.userByStrategyId(
        this.$v._user_strategy_id.$model
      )
      return (
        this.$v._user_strategy_id.$model._assignedTo !== ticketOwner.strategyId
      )
    }
  },
  watch: {
    typeIsSubTask(val) {
      if (val) this.fetchIntTickets()
    }
  },
  async mounted() {
    await this.findUsers()
  },
  methods: {
    ...mapActions({
      findUsers: 'provider/users/find'
    }),
    find(service) {
      if (service) return this.$store.state.provider[service].all
    },
    async fetchIntTickets() {
      // this.loadingIntTickets = true
      // await this.$store.dispatch('fetchIntTickets')
      // this.loadingIntTickets = false
    },
    assignToOwner() {
      if (this.ticket._user_id !== this.ticket._assignedTo) {
        const ticketOwner = this.$store.getters.userById(this.ticket._user_id)
        if (!ticketOwner) {
          // return this.toaster({ type: 'WARNING', message: 'Assign To Failed' })
        }
        this.$store.dispatch('ticketAssignedTo', ticketOwner.strategyId)
      }
    }
  }
}
</script>
